import { db } from '../data_oscbase';

export class BaseService {
  constructor(tableName) {
    this.table = db[tableName];
  }

  // Create
  async create(data) {
    try {
      const id = await this.table.add({
        ...data,
        createdAt: new Date(),
        updatedAt: new Date()
      });
      return this.getById(id);
    } catch (error) {
      console.error(`Error creating ${this.table.name}:`, error);
      throw error;
    }
  }

  // Read
  async getAll() {
    try {
      return await this.table.toArray();
    } catch (error) {
      console.error(`Error getting all ${this.table.name}:`, error);
      throw error;
    }
  }

  async getById(id) {
    try {
      return await this.table.get(id);
    } catch (error) {
      console.error(`Error getting ${this.table.name} by id:`, error);
      throw error;
    }
  }

  async getByField(field, value) {
    try {
      return await this.table.where(field).equals(value).toArray();
    } catch (error) {
      console.error(`Error getting ${this.table.name} by field:`, error);
      throw error;
    }
  }

  // Update
  async update(id, data) {
    try {
      await this.table.update(id, {
        ...data,
        updatedAt: new Date()
      });
      return this.getById(id);
    } catch (error) {
      console.error(`Error updating ${this.table.name}:`, error);
      throw error;
    }
  }

  // Delete
  async delete(id) {
    try {
      await this.table.delete(id);
      return true;
    } catch (error) {
      console.error(`Error deleting ${this.table.name}:`, error);
      throw error;
    }
  }

  // Pagination
  async getPaginated(page = 1, pageSize = 10, filters = {}) {
    try {
      let query = this.table;
      
      // Apply filters
      Object.entries(filters).forEach(([field, value]) => {
        if (value) {
          query = query.where(field).equals(value);
        }
      });

      const total = await query.count();
      const items = await query
        .offset((page - 1) * pageSize)
        .limit(pageSize)
        .toArray();

      return {
        items,
        total,
        page,
        pageSize,
        totalPages: Math.ceil(total / pageSize)
      };
    } catch (error) {
      console.error(`Error getting paginated ${this.table.name}:`, error);
      throw error;
    }
  }

  // Search
  async search(query, fields = []) {
    try {
      let results = [];
      
      for (const field of fields) {
        const fieldResults = await this.table
          .where(field)
          .startsWithIgnoreCase(query)
          .toArray();
        results = [...results, ...fieldResults];
      }

      // Remove duplicates
      return [...new Map(results.map(item => [item.id, item])).values()];
    } catch (error) {
      console.error(`Error searching ${this.table.name}:`, error);
      throw error;
    }
  }
} 